/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Footnote_HintInputs */

const en_reading_class_footnote_hint = /** @type {(inputs: Reading_Class_Footnote_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes at the bottom of a page`)
};

const es_reading_class_footnote_hint = /** @type {(inputs: Reading_Class_Footnote_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas al final de una página`)
};

/**
* | output |
* | --- |
* | "Notes at the bottom of a page" |
*
* @param {Reading_Class_Footnote_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_footnote_hint = /** @type {((inputs?: Reading_Class_Footnote_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Footnote_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_footnote_hint(inputs)
	return en_reading_class_footnote_hint(inputs)
});